import { render, staticRenderFns } from "./BillingToOrder.vue?vue&type=template&id=64ef134c&scoped=true"
import script from "./BillingToOrder.vue?vue&type=script&lang=js"
export * from "./BillingToOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef134c",
  null
  
)

export default component.exports